export default __webpack_public_path__ + "static/media/README.0335aee8.md";